{
  "CONFIG_EDITOR": {
    "CREATE_CONFIG": "Create configuration",
    "ERROR": {
      "ACCOUNT_GROUP_REQUIRED": "Account is required",
      "NAME_REQUIRED": "Name is required",
      "NAME_EXISTS": "A configuration with this name already exists",
      "NO_MATCHING_ACCOUNT_GROUPS_FOUND": "No matching accounts found"
    },
    "NAME": "Name",
    "SOURCE_ACCOUNT_GROUP": "Source account",
    "NO_OBJECTS": {
      "TITLE": "No available objects to configure",
      "DESCRIPTION": "This source has no configurable objects. Choose a different source to continue."
    }
  },
  "COMMON": {
    "SAVE": "Save",
    "SAVE_AND_CONTINUE": "Save and continue",
    "NEXT": "Next",
    "BACK": "Back",
    "EDIT": "Edit",
    "CANCEL": "Cancel",
    "CREATE": "Create",
    "APPLY": "Apply",
    "CLOSE": "Close",
    "YES": "Yes",
    "NO": "No"
  },
  "CONFIG_MANAGER": {
    "CREATE_CONFIG": "Create configuration",
    "CONFIGURATIONS": "Configurations"
  },
  "CONFIG_LIST": {
    "NAME": "Name",
    "SOURCE": "Source",
    "CONTAINS": "Contains",
    "ACTIONS": "Actions",
    "EMPTY_STATE": "No configurations found",
    "EMPTY_STATE_ACTION": "Create a configuration from one account, to apply to others"
  },
  "CONFIG_DETAILS": {
    "NAME": "Name",
    "SOURCE": "Source",
    "CONTAINS": "Contains",
    "LOAD_ERROR": "Error loading configuration",
    "ACCOUNT_GROUP_ERROR": "Error loading account group data"
  },
  "CONFIG_CARD": {
    "APPLY_TO": "Apply to",
    "SOURCE": "Source",
    "CONTAINS": "Contains",
    "DELETE": "Delete",
    "DELETE_SUCCESS": "Configuration deleted successfully",
    "DELETE_ERROR": "Failed to delete configuration"
  },
  "CONFIG_APPLIER": {
    "TITLE": "Apply configuration",
    "TARGET_TYPE": "Type",
    "TARGET_TYPE_PLACEHOLDER": "Type",
    "TARGET_NAME": "Name",
    "TARGET_NAME_PLACEHOLDER": "Search for a name",
    "CONTAINER_TYPE": {
      "ACCOUNT_GROUP": "Account",
      "MULTI_LOCATION_GROUP": "Multi location group"
    },
    "SERVICE_ACCOUNT_SELECTOR_LABEL": "Select service account",
    "SERVICE_ACCOUNT_SELECTOR_PLACEHOLDER": "Search for a name",
    "CONFIG_SELECTOR_LABEL": "Select configuration",
    "CONFIG_OPTIONS_LABEL": "Select objects to apply",
    "SUBMISSION_SUCCESS": "Application process started",
    "SUBMISSION_ERROR": "Error applying configuration",
    "NO_ACCOUNTS_ALERT": "Selected companies have no associated accounts",
    "TARGET_SELECTOR_LABEL": "Select target"
  },
  "CONFIG_DELETE": {
    "TITLE": "Delete configuration",
    "MESSAGE": "Are you sure you want to delete the following items:"
  },
  "WARNING": {
    "EXTERNAL_DEPENDENCY": {
      "AUTOMATION_PARAMETER": "automation has an external dependency for a parameter in a task definition",
      "AUTOMATION_PARAMETER_VALUE_ERROR": "automation has an external dependency for a parameter in a task definition, but the value could not be extracted",
      "EXTENSION_FIELD_REQUIRED": "Extension field required",
      "CUSTOM_FIELD_REQUIRED": "Custom field required",
      "AI_TOOL_REQUIRED": "AI tool required"
    },
    "STATIC_LIST": {
      "INITIALIZATION": "This list is static. It will be initialized using the criteria, but the values may differ from the source list."
    }
  }
}
